export default __webpack_public_path__ + "static/media/logo.f70dcce7.png";